/**
 * 管理deviceId
 */
let deviceId = null
export const createDeviceId = () => {
  if (deviceId) {
    return deviceId
  }

  if (window.localStorage.getItem('deviceId')) {
    deviceId = window.localStorage.getItem('deviceId')
    return deviceId
  }

  const originDeviceId = 'nzweb-' + Math.random()
  deviceId = window.btoa(originDeviceId)
  window.localStorage.setItem('deviceId', deviceId)
  return deviceId
}

export const getDevicesId = () => {
  if (deviceId) {
    return deviceId
  }

  if (window.localStorage.getItem('devicesId')) {
    deviceId = window.localStorage.getItem('devicesId')
    return deviceId
  }

  const originDeviceId = 'nzweb-' + Math.random()
  deviceId = window.btoa(originDeviceId)
  window.localStorage.setItem('devicesId', deviceId)
  return deviceId
}

// 目前来看localstorage读取少量本地数据是够用的
// 如果后期涉及到大量本地数据的时候需要实现该方法
export const getLocalFields = () => { }
